var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 218,
  height: 6,
  viewBox: "0 0 218 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M217 3.6561C207.982 3.6561 198.972 4.55203 189.954 4.55203C182.525 4.55203 175.095 4.55203 167.665 4.55203C161.915 4.55203 156.168 5 150.426 5C144.142 5 137.851 4.10407 131.562 4.10407C121.567 4.10407 110.645 4.10407 100.66 4.10407C86.9978 4.55203 74.6235 2.38759 61.1312 2.38759C46.1855 2.38759 31.1459 1.93962 16.2873 1.93962C15.2809 1.93962 14.0579 1.93962 13.0515 1.93962C12.1167 1.93962 11.014 1.70787 10.0937 1.61028C9.13039 1.50812 7.57994 1.21691 6.7134 1.09529C5.18553 0.880842 4.93378 1.09533 3.74011 1.09533C2.82674 1.09533 1.91337 1.09533 1 1.09533",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgImgLine;